import { z } from 'zod'

export const placeOrderSchema = z
  .object({
    instrumentUid: z.string().min(1),
    direction: z.enum(['buy', 'sell']),
    quantity: z.number().int().min(1),
    orderType: z.enum(['market', 'limit']),
    price: z.number().positive().optional(),
  })
  .refine((data) => data.orderType !== 'limit' || data.price !== undefined, {
    message: 'Price is required for limit orders',
    path: ['price'],
  })

export type PlaceOrderDto = z.infer<typeof placeOrderSchema>
